function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".xxs_svg__cls-1{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "xxs_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "xxs_svg__Extra_Assets",
  "data-name": "Extra Assets"
}, /*#__PURE__*/React.createElement("path", {
  className: "xxs_svg__cls-1",
  transform: "rotate(-45 5.53 5.53)",
  d: "M5.15-1.91h.75v14.88h-.75z"
}), /*#__PURE__*/React.createElement("path", {
  className: "xxs_svg__cls-1",
  transform: "rotate(-45.05 5.522 5.526)",
  d: "M-1.91 5.15h14.88v.75H-1.91z"
}), /*#__PURE__*/React.createElement("path", {
  className: "xxs_svg__cls-1",
  transform: "rotate(-45 137.97 5.53)",
  d: "M137.59-1.91h.75v14.88h-.75z"
}), /*#__PURE__*/React.createElement("path", {
  className: "xxs_svg__cls-1",
  transform: "rotate(-45.05 137.977 5.521)",
  d: "M130.53 5.15h14.88v.75h-14.88z"
}), /*#__PURE__*/React.createElement("path", {
  className: "xxs_svg__cls-1",
  transform: "rotate(-45 520.671 5.531)",
  d: "M520.32-1.91h.75v14.88h-.75z"
}), /*#__PURE__*/React.createElement("path", {
  className: "xxs_svg__cls-1",
  transform: "rotate(-45.05 520.725 5.522)",
  d: "M513.25 5.15h14.88v.75h-14.88z"
})));

const SvgXxs = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 526.22 11.05"
}, props), _ref, _ref2);

export default SvgXxs;